import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_USER_WEB_LOGIN_FORM_MUTATION = gql`
  mutation Post($email: String!, $password: String!) {
    userWebLogin(email: $email, password: $password) {
      token
    }
  }
`;

const postUserWebLoginForm = async ({
  email,
  password,
}) => {
  try {
    const result = await client.mutate({
      mutation: POST_USER_WEB_LOGIN_FORM_MUTATION,
      variables: {
        email,
        password,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { userWebLogin: validatedFormData } } = result;

    if (validatedFormData) {
      return validatedFormData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: validatedFormData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: userWebLogin Error: ${error}`);
    return null;
  }
};

export default postUserWebLoginForm;
